import { render, staticRenderFns } from "./affiliate-link-edit-modal.vue?vue&type=template&id=70d62081&scoped=true&"
import script from "./affiliate-link-edit-modal.vue?vue&type=script&lang=ts&"
export * from "./affiliate-link-edit-modal.vue?vue&type=script&lang=ts&"
import style0 from "./affiliate-link-edit-modal.vue?vue&type=style&index=0&id=70d62081&lang=scss&scoped=true&"
import style1 from "./affiliate-link-edit-modal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d62081",
  null
  
)

export default component.exports